import { render, staticRenderFns } from "./mis-vacantes.vue?vue&type=template&id=5273be37&scoped=true&"
import script from "./mis-vacantes.vue?vue&type=script&lang=js&"
export * from "./mis-vacantes.vue?vue&type=script&lang=js&"
import style0 from "./mis-vacantes.vue?vue&type=style&index=0&id=5273be37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5273be37",
  null
  
)

export default component.exports